'use client';

import { FC } from 'react';

type TTitle = {
  translation: (key: string) => string;
};

export const Title: FC<TTitle> = (props) => {
  return (
    <div className="flex flex-col justify-between min-h-[70px] md:flex-row">
      <div>
        <div className="text-3xl font-bold pb-3">
          {props.translation('title')}
        </div>

        <div className="text-sm font-normal w-full pb-3 md:pb-0 md:w-[500px]">
          {props.translation('description')}
        </div>
      </div>
    </div>
  );
};
